import React, { useState, useEffect } from 'react';
import './App.css';
import Welcome from './components/Welcome';
import Navbar from './components/Navbar';
import MonthPlan from './components/MonthPlan';
import MonthReflection from './components/MonthReflection';
import Dashboard from './components/Dashboard';
import YearView from './components/YearView';
import YearComparison from './components/YearComparison';
import OverallDashboard from './components/OverallDashboard';

const MONTHS = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

function App() {
  // Iniciar en Enero del año actual (mes 0)
  const currentYear = new Date().getFullYear();
  const [showWelcome, setShowWelcome] = useState(true);
  const [currentView, setCurrentView] = useState('year'); // 'dashboard', 'months', 'year', 'comparison', 'overall'
  const [currentMonth, setCurrentMonth] = useState(0);
  const [currentYearState, setCurrentYearState] = useState(currentYear);
  const [isPrinting, setIsPrinting] = useState(false);

  useEffect(() => {
    const handleBeforePrint = () => setIsPrinting(true);
    const handleAfterPrint = () => setIsPrinting(false);

    window.addEventListener('beforeprint', handleBeforePrint);
    window.addEventListener('afterprint', handleAfterPrint);

    return () => {
      window.removeEventListener('beforeprint', handleBeforePrint);
      window.removeEventListener('afterprint', handleAfterPrint);
    };
  }, []);

  const handlePrint = () => {
    window.print();
  };

  const handleEnterApp = () => {
    setShowWelcome(false);
  };

  const handleMonthClick = (monthIndex) => {
    setCurrentMonth(monthIndex);
    setCurrentView('months');
  };

  if (showWelcome) {
    return <Welcome onEnter={handleEnterApp} />;
  }

  return (
    <div className="App">
      {!isPrinting && (
        <Navbar
          currentMonth={currentMonth}
          onMonthChange={setCurrentMonth}
          currentYear={currentYearState}
          onYearChange={setCurrentYearState}
          onPrint={handlePrint}
          monthName={MONTHS[currentMonth]}
          currentView={currentView}
          onViewChange={setCurrentView}
        />
      )}

      {currentView === 'dashboard' ? (
        <Dashboard year={currentYearState} />
      ) : currentView === 'year' ? (
        <YearView year={currentYearState} onMonthClick={handleMonthClick} />
      ) : currentView === 'comparison' ? (
        <YearComparison />
      ) : currentView === 'overall' ? (
        <OverallDashboard />
      ) : (
        <div className="months-container">
          {MONTHS.map((month, index) => (
            <div 
              key={index} 
              className={`month-pages ${index === currentMonth ? 'current-month' : ''}`}
            >
              <div className="page page-a">
                <MonthPlan monthIndex={index} monthName={month} year={currentYearState} />
              </div>
              <div className="page page-b">
                <MonthReflection monthIndex={index} monthName={month} year={currentYearState} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default App;

